module.exports = {"650107001":"艾维尔沟街道","650107004":"乌拉泊街道","650107006":"达坂城区盐湖街道","650107100":"达坂城镇","650107200":"东沟乡","650107201":"西沟乡","650107202":"阿克苏乡","650107400":"柴窝堡管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650107.json
// module id = 2839
// module chunks = 0